// extracted by mini-css-extract-plugin
export default {"fabrics":"sXz1s","fabricItem":"YWUWy","hidden":"Clmsz"};